import "@fortawesome/fontawesome-free/css/all.min.css";
import React from "react";

import { Container } from "react-bootstrap";
import Particle from "../Particle";
import "./AboutMe.css";
import "bootstrap/dist/css/bootstrap.min.css";
import About from "./About";

function AboutMe() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <About />
      </Container>
    </section>
  );
}

export default AboutMe;
